<template>
  <a-modal
    :visible="visible"
    :width="600"
    wrap-class-name="format-history-modal"
    :destroy-on-close="true"
    :cancel-text="closeTitTxt"
    :mask="false"
    :closable="false"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <div class="top">
      <p><label>{{ $t('message["582"]') }}：</label>{{ data.from_url }}</p>
      <p>
        <label>{{ $t('message["580"]') }}IP：</label>{{ data.from_ip }}  <span
          v-if="data.from_ip_city"
          class="city fs-gray"
        >[{{ data.from_ip_city }}]</span>
      </p>
      <p><label>{{ $t('message["1170"]') }}：</label>{{ $moment(data.addtime * 1000).format('YYYY-MM-DD HH:mm:ss') }}</p>
      <p><label>{{ $t('message["1973"]') }}：</label>{{ data.from_agent || '- -' }}</p>
    </div>
    <div class="content clearfix">
      <div
        v-for="(item, index) in data.all"
        :key="index"
        class="item clearfix"
      >
        <i
          v-if="item.ismatch"
          class="iconfont iconicon-test70 success-icon"
        />
        <i
          v-else
          class="iconfont iconicon-test68 fail-icon"
        />
        <span class="fieldkey">{{ item.fieldname }}：</span>
        <div class="value">
          <div
            v-if="item.fieldtype === 'editor'"
            :class="item.fieldtype"
            v-html="$xss(item.fieldvalue, $xssOptions)"
          />
          <div
            v-else-if="item.fieldtype === 'select_tree'"
            :class="item.fieldtype"
          >
            <p>{{ item.fieldvalue && setSelectVal(item.fieldvalue.treedata, ',') }}</p>
            <p>{{ item.fieldvalue && item.fieldvalue.input }}</p>
          </div>
          <div
            v-else-if="item.fieldtype === 'area'"
            :class="item.fieldtype"
          >
            <p>{{ item.fieldvalue && setSelectVal(item.fieldvalue.code, '/') }}</p>

            <p>{{ item.fieldvalue && item.fieldvalue.address }}</p>
          </div>
          <div
            v-else-if="item.fieldtype === 'file'"
            :class="item.fieldtype"
            class="file-box"
          >
            <p
              v-for="(file, k) in item.fieldvalue"
              :key="k"
              @click="handleFileGallery(file, k)"
            >
              <a>{{ file.file_name || file.file_url }}</a>
            </p>
          </div>
          <div
            v-else-if="item.fieldtype === 'select' || item.fieldtype === 'radio' || item.fieldtype === 'checkbox'"
            :class="item.fieldtype"
          >
            {{ setSelectVal(item.fieldvalue, ',') }}
          </div>
          <div
            v-else-if="item.fieldtype === 'datetime'"
            :class="item.fieldtype"
          >
            {{ item.fieldvalue }}
          </div>
          <div
            v-else
            :class="item.fieldtype"
          >
            {{ item.fieldvalue }}
          </div>
        </div>
      </div>
    </div>
  </a-modal>
</template>

<script>
import { getFormatHistory } from '@/services/universalForm'

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    formHistoryId: {
      type: [String, Number],
      default: () => { }
    }
  },
  data () {
    return {
      data: {},
      fileIndex1: null
    }
  },
  computed: {
    closeTitTxt () {
      return this.$t('message["401"]')
    },
    cancelTxt () {
      return this.$t('message["896"]')
    }
  },
  watch: {
    visible (val) {
      if (val) {
        setTimeout(() => {
          document.body.style.overflow = 'auto'
        }, 30)
      }
    }
  },
  created () {
    if (this.formHistoryId) {
      this.getFormatHistory()
    }
  },
  methods: {
    async getFormatHistory () {
      const chain = await getFormatHistory()
      chain
        .params({
          formid: this.formHistoryId
          // formid: this.formHistoryId || 125
          // formid: this.formHistoryId || 115
        })
        .onSuccess(payload => {
          payload.all.forEach(item => {
            if (item.fieldtype === 'file' && Array.isArray(item.fieldvalue)) {
              item.fieldvalue.forEach(file => {
                file.description = file.name
                file.href = file.file_url
                file.title = this.$t('message["1304"]')
              })
            }
          })
          this.data = payload
        })
        .fetch()
    },
    hide () {
      this.$emit('update:visible', false)
    },
    async handleOk () {

    },
    handleCancel () {
      this.hide()
    },
    setSelectVal (value = {}, separator = ',') {
      const values = Object.values(value) || []
      return values.join(separator)
    },
    handleFileGallery (item, k) {
      if (item.file_type.indexOf('image') === -1) {
        this.$confirm({
          title: this.$t('message["1099"]') + '？',
          okText: this.$t('message["915"]'),
          cancelText: this.$t('message["896"]'),
          centered: true,
          // closable: true,
          onOk: () => {
            // window.open(item.url || item.file_url)
            this.$downloadFile(item.url || item.file_url)
          }
        })
      } else {
        this.$bus.$emit('getFileGallery', item.fieldvalue, k)
      }
    }
  }
}
</script>

<style lang="scss">
.format-history-modal {
  height: calc(100% - 300px);
  top: inherit;
  left: inherit;
  bottom: 64px;
  overflow: inherit;
  .ant-modal {
    top: 0;
    height: 100%;
    overflow: scroll;
    padding-bottom: 0;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }
  .ant-modal-body {
    padding: 0;
    padding-bottom: 70px;
  }
  .ant-modal-content {
    min-height: 100%;
  }
  .ant-modal-footer {
    position: fixed;
    bottom: 64px;
    width: 600px;
    text-align: center;
    background-color: #fff;
  }
  .ant-btn-primary {
    display: none;
  }
  .success-icon {
    color: #42c27e;
  }
  .fail-icon {
    color: #f6a953;
  }
  .top {
    width: 600px;
    // height: 72px;
    padding: 12px 24px;
    color: #333;
    background: rgba(245, 246, 247, 1);
    border-radius: 4px 4px 0px 0px;
    label {
      width: 80px;
      text-align: right;
    }
  }
  .content {
    margin-top: 20px;
  }
  .item {
    margin-bottom: 28px;
    padding: 0 20px;
    font-size: 14px;
    .iconfont {
      float: left;
    }
    .fieldkey {
      float: left;
      width: 134px;
      margin-right: 16px;
      text-align: right;
      color: #666;
    }
    .value {
      float: left;
      width: 370px;
      color: #333;
      .editor {
        // width: 400px;
        height: 160px;
        padding: 10px;
        overflow: auto;
        background: rgba(255, 255, 255, 1);
        border-radius: 4px;
        border: 1px solid rgba(214, 214, 214, 1);
      }
      .email {
        margin-top: 0;
      }
    }
  }
}
</style>
